import { useState } from 'react'
import { SignedIn, SignedOut, SignInButton, UserButton } from '@clerk/clerk-react'
import { AlbumPage } from '@/pages/AlbumPage'
import { UploadPage } from '@/pages/UploadPage'
import { StatisticsPage } from '@/pages/StatisticsPage'
import { Film, Upload, BarChart3 } from 'lucide-react'

type Page = 'album' | 'upload' | 'statistics'

export default function App() {
  const [currentPage, setCurrentPage] = useState<Page>('album')

  const renderPage = () => {
    switch (currentPage) {
      case 'album':
        return <AlbumPage />
      case 'upload':
        return <UploadPage />
      case 'statistics':
        return <StatisticsPage />
    }
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="fixed top-0 left-0 right-0 z-50 glass-effect border-b border-border">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold">
            <span className="netflix-gradient bg-clip-text text-transparent">Netflix Album</span>
          </h1>

          <SignedIn>
            <nav className="flex items-center gap-2">
              <button
                onClick={() => setCurrentPage('album')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all ${
                  currentPage === 'album'
                    ? 'netflix-gradient text-white'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <Film className="w-4 h-4" />
                <span className="hidden sm:inline">アルバム</span>
              </button>
              <button
                onClick={() => setCurrentPage('upload')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all ${
                  currentPage === 'upload'
                    ? 'netflix-gradient text-white'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <Upload className="w-4 h-4" />
                <span className="hidden sm:inline">アップロード</span>
              </button>
              <button
                onClick={() => setCurrentPage('statistics')}
                className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all ${
                  currentPage === 'statistics'
                    ? 'netflix-gradient text-white'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <BarChart3 className="w-4 h-4" />
                <span className="hidden sm:inline">統計</span>
              </button>
            </nav>
          </SignedIn>

          <div className="flex items-center gap-4">
            <SignedOut>
              <SignInButton mode="modal">
                <button className="netflix-gradient px-4 py-2 text-white rounded-md hover:opacity-90 transition-opacity">
                  ログイン
                </button>
              </SignInButton>
            </SignedOut>
            <SignedIn>
              <UserButton />
            </SignedIn>
          </div>
        </div>
      </header>

      <main className="pt-20 min-h-screen">
        <SignedOut>
          <div className="text-center py-20 animate-slide-up">
            <h2 className="text-5xl font-bold mb-4">
              あなたの<span className="netflix-gradient bg-clip-text text-transparent">Netflix</span>視聴履歴を
            </h2>
            <h3 className="text-3xl font-light mb-6">美しいアルバムに変換</h3>
            <p className="text-muted-foreground mb-8 text-lg">
              視聴履歴CSVをアップロードして、あなただけの視聴アルバムを作成しましょう
            </p>
            <SignInButton mode="modal">
              <button className="netflix-gradient px-8 py-4 text-white rounded-lg text-lg font-semibold hover:opacity-90 transition-opacity shadow-lg">
                始める
              </button>
            </SignInButton>
          </div>
        </SignedOut>

        <SignedIn>
          <div className="container mx-auto px-4 py-8">
            {renderPage()}
          </div>
        </SignedIn>
      </main>
    </div>
  )
}
